import React from "react";
import { useEffect } from "react";
import { AppRoute } from "./routes/AppRoute";
import { UserTokenKey ,LANG_COOKIE} from "../../Constants";
import { setAuthorizationHeader } from "../../helpers/CookieToken";
import { useAuth } from "../../hooks";
import {useTranslation} from 'react-i18next';
import Cookies from "universal-cookie";

export const AppLogin = () => {
  const { SessionLogin } = useAuth();
  const [t] = useTranslation("global");

  useEffect(() => {
    (async () => {
      //Checamos Si tenemos una Session iniciada
      const sessionItem = JSON.parse(localStorage.getItem(UserTokenKey));
      if (sessionItem) {
        setAuthorizationHeader(sessionItem.token);
        await SessionLogin({
          refreshToken: `${sessionItem.refreshToken}`,
          idUser: sessionItem.idUser,
        });
      }
      const cookies = new Cookies();
      cookies.set(LANG_COOKIE, t("CurrentLenguaje").toLowerCase() ,{path:"/"});
    })();
  }, []);

  return (
    <div className="h-[100vh]">
      <AppRoute />
    </div>
  );
};
